import SchedulePaymentScreen from 'features/believe/makePayment/SchedulePaymentScreen/SchedulePaymentScreen';
import React from 'react';

export default function Page() {
  return <SchedulePaymentScreen />;
}
